import React from 'react';
import cx from 'classnames';
import { useCart } from '@shared/cart-react';
import s from './discountBanner.module.scss';

const DiscountBanner = () => {
  const { promoCodeDescription } = useCart();
  const discountApplied = promoCodeDescription?.some?.(
    (code) => false && code.includes('PERKSPOT25')
  );

  return (
    <div
      className={cx(s.discount, {
        [s.discountHide]: !discountApplied,
      })}
    >
      <div className={s.discountWrapper}>
        <p className={s.discountText}>Your $25 discount has been applied!</p>
      </div>
    </div>
  );
};

export default DiscountBanner;
